import { Component, Input, OnInit } from '@angular/core';

import { ChipListItem } from '../../shared.interface';

@Component({
    selector: 'app-chip-list-item',
    templateUrl: './chip-list-item.component.html',
    styleUrls: ['./chip-list-item.component.scss'],
})
export class ChipListItemComponent implements OnInit {
    @Input() chipConfig: ChipListItem;

    constructor() {}

    ngOnInit(): void {}
}
